import type { AirlineCompany } from '@/app/components/hotel-detail/evo/transport/EvoTransportDetailsCard/EvoTransport/EvoTransportTimeline';

type CompanySegment = {
  transport: {
    companyCode: string;
    companyName: string;
    type: string;
  };
};

export function toUniqueCompanies(segments: CompanySegment[]): AirlineCompany[] {
  return [
    ...new Map(
      segments.map((s) => [
        `${s.transport.companyCode}_${s.transport.type}`,
        { code: s.transport.companyCode, name: s.transport.companyName, type: s.transport.type },
      ])
    ).values(),
  ];
}
